import { Component } from '@theme/component';
import { morph } from '@theme/morph';

/** Small read-only enhancement; cart line mutations remain owned by native Horizon.
 * @extends {Component<{results: HTMLElement}>}
 */
class BpCartComplements extends Component {
  requiredRefs = ['results'];
  static observedAttributes = ['data-product-id', 'data-cart-ids'];
  #controller;
  #signature = '';

  connectedCallback() {
    super.connectedCallback();
    this.#load();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#load();
  }

  attributeChangedCallback() {
    if (this.isConnected) queueMicrotask(() => this.isConnected && this.#load());
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    this.#signature = '';
  }

  async #load() {
    const signature = `${this.dataset.productId}/${this.dataset.cartIds}`;
    if (!this.refs.results || !this.dataset.productId || signature === this.#signature) return;
    this.#signature = signature;
    this.#controller?.abort();
    const controller = new AbortController();
    this.#controller = controller;
    // Keep the verified server-rendered pair usable while optional native selections load.
    // Cart section responses already render the current cart's eligible pair.
    const url = new URL(this.dataset.url, location.origin);
    url.searchParams.set('product_id', this.dataset.productId);
    url.searchParams.set('intent', 'complementary');
    url.searchParams.set('limit', '3');
    url.searchParams.set('section_id', 'bp-cart-complements');
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) return;
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = document.querySelector('[data-bp-cart-complements]');
      if (controller.signal.aborted || !this.isConnected || signature !== this.#signature || !content) return;
      morph(this.refs.results, content);
    } catch (error) {
      // Optional merchandising never blocks cart controls or checkout on request failure.
      if (error?.name !== 'AbortError') this.dataset.unavailable = 'true';
    }
  }
}
if (!customElements.get('bp-cart-complements-component')) {
  customElements.define('bp-cart-complements-component', BpCartComplements);
}
